import { AbstractControl } from '@angular/forms';
import { getFormattedDateString } from '@mng/mng-ts-helpers';

export type messageFunc = (error, control: AbstractControl) => string;
export type messageResolver = string | messageFunc;

export interface IMessageResolvers {
  [key: string]: messageResolver;
}

export interface IMessageDef {
  key: string;
  resolver: messageResolver;
}

export const longValidationMessages: IMessageResolvers = {
  required: 'Eingabe ist erforderlich',
  email: 'Die Email Adresse ist ungültig',
  emailExists: 'Benutzer mit Email Adresse existiert schon',
  url: 'Ungültige URL (Beispiel für eine korrekte URL: http://meineseite.at)',
  minlength: (error) => `Die Eingabe ist zu kurz (akt. ${error.actualLength} Zeichen / min. ${error.requiredLength})`,
  maxlength: (error) => `Die Eingabe ist zu lang (akt. ${error.actualLength} Zeichen / max. ${error.requiredLength})`,
  max: (error) => `Die Eingabe ist zu groß (max. ${error.max})`,
  min: (error) => `Die Eingabe ist zu klein (min. ${error.min})`,
  matDatepickerMin: (error) => `Das Datum ist zu klein ( min. ${getFormattedDateString(error.min)} )`,
  matDatepickerMax: (error) => `Das Datum ist zu groß ( max. ${getFormattedDateString(error.max)} )`,
  pattern: 'Die Eingabe enhält ungültige Zeichen'
};

export const validationMessages: IMessageResolvers = {
  required: 'Pflichteingabe',
  email: 'Ungültige Email Adresse',
  emailExists: 'Benutzer mit Email Adresse existiert schon',
  url: 'Ungültige URL',
  minlength: (error) => `min. ${error.requiredLength} Zeichen`,
  maxlength: (error) => `max.${error.requiredLength} Zeichen`,
  max: (error) => `zu groß (max. ${error.max})`,
  min: (error) => `zu klein (min. ${error.min})`,
  matDatepickerMin: (error) => `zu klein ( min. ${getFormattedDateString(error.min)} )`,
  matDatepickerMax: (error) => `zu groß ( max. ${getFormattedDateString(error.max)} )`,
  pattern: 'Ungültige Zeichen'
};

export function getMessage(
  key: string,
  error: any,
  customerResolvers?: IMessageResolvers,
  control?: AbstractControl
): string {
  let resolver: messageResolver;

  if (customerResolvers) {
    resolver = customerResolvers[key];
  }

  if (!resolver) {
    resolver = validationMessages[key];
  }

  if (!resolver) {
    return typeof error === 'string' ? error : key;
  } else if (typeof resolver === 'string') {
    return resolver;
  } else {
    return resolver(error || {}, control);
  }
}

export function getValidationMessage(control: AbstractControl, customerResolvers?: IMessageResolvers): string {
  if (!control.errors) {
    return null;
  }

  // Den ersten Error verwenden
  const errorKey = Object.keys(control.errors)[0];
  const error = control.getError(errorKey);
  return getMessage(errorKey, error, customerResolvers, control);
}
